export default __webpack_public_path__ + "static/media/showroom43.81178f0f.jpg";